module.exports = __webpack_public_path__ + "static/controle-3-78d9a46e31322b0a5f7f9d83fe48932d.jpg";